// The invoice freezes its dates; changing today's settings never recalculates them.
export function warrantyState(row, now = Date.now()) {
  if (row.duration_days === 0) return { status: "none", label: "Tanpa garansi", remaining: 0 };
  const end = Date.parse(row.expires_at || "");
  const start = Date.parse(row.start_date ? `${row.start_date}T00:00:00+07:00` : "");
  if (!(row.duration_days > 0) || !Number.isFinite(start) || !Number.isFinite(end) || end <= start)
    return { status: "unknown", label: "Masa garansi belum tercatat", remaining: 0 };
  if (now < start) return { status: "upcoming", label: "Belum dimulai", remaining: 100 };
  if (now >= end) return { status: "expired", label: "Masa garansi berakhir", remaining: 0 };
  const minutes = Math.max(1, Math.ceil((end - now) / 60000));
  const days = Math.floor(minutes / 1440), hours = Math.floor((minutes % 1440) / 60), mins = minutes % 60;
  const countdown = [days ? `${days} hari` : "", hours ? `${hours} jam` : "", `${mins} menit`].filter(Boolean).join(" · ");
  return { status: "active", label: "Aktif", countdown, remaining: Math.max(0, Math.min(100, (end - now) / (end - start) * 100)) };
}
